import axios from 'axios';

// 获取当前站配置的ListingStatus
// https://wh.chimewiki.me/pages/viewpage.action?pageId=40509708
export const getListingStatus = params => {
    return axios.get('/api-site/snapshot/listing-status', { params });
};
// 根据listingStatus获取房源数据
// https://wh.chimewiki.me/pages/viewpage.action?pageId=40509708
export const getSnapshotListing = params => {
    return axios.get(`/api-site/snapshot/listings`, { params });
};
// market report 接口
// https://wh.chimewiki.me/pages/viewpage.action?pageId=40509708
export const getMarketReport = params => {
    // params = Object.keys(params).reduce((prev, cur) => {
    //     const value = params[cur];
    //     if (value === null) return prev;
    //     prev += `&${encodeURIComponent(cur)}=${encodeURIComponent(value)}`;
    //     return prev;
    // }, '');
    return axios.get(`/api-site/snapshot/market-report`, { params });
};
